import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import KycRfiCard from 'components/KycRfi/KycRfiCard';
import KycRfiForm from 'components/KycRfi/KycRfiForm';

const RaiseChildRfiModal = ({
  isOpen,
  onClose,
  rfi,
  entityId,
  fetchKycDetails,
  documentInfo,
  isSubmittedRfi,
  rfiTemplates,
  rfiTagTypes,
  rfiTagSubtypes,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size='full'>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Raise RFI</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <KycRfiCard rfi={rfi} isSubmittedRfi={isSubmittedRfi} />
          <KycRfiForm
            entityId={entityId}
            fetchKycDetails={fetchKycDetails}
            documentInfo={documentInfo}
            parentRfiId={rfi?.id}
            rfiTemplates={rfiTemplates}
            rfiTagTypes={rfiTagTypes}
            rfiTagSubtypes={rfiTagSubtypes}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default RaiseChildRfiModal;
